export default __webpack_public_path__ + "static/media/icon-logo-nav.d129af54.png";